export const enum MonthRangeOption {
    YearToDate = "yearToDate",
    LastYear = "lastYear",
    Custom = "custom",
}
